import "./comentarios.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../0. Utilidades/LoadingOverlay"; // Import the LoadingOverlay component

function Comments() {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // State to manage loading state
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleRowClick = (rut) => {
    navigate(`/todas/${rut}`); // Use navigate to change the route
  };

  useEffect(() => {
    // Function to fetch recent comments
    const fetchComments = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/tabla/comentarios_mes/`;
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setComments(data);
        setIsLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Failed to fetch recent comments", error);
        setIsLoading(false); // Ensure loading is set to false even on error
      }
    };

    // Call the fetch function
    fetchComments();
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div id="comments">
      {isLoading && <LoadingOverlay />}{" "}
      {/* Display LoadingOverlay if isLoading is true */}
      <div className="comm-0">Comentarios últimos 30 días</div>
      {comments.map((comment) => (
        <div
          className="comm-1"
          key={comment.id}
          onClick={() => handleRowClick(comment.maestra)}
        >
          <div className="comm-11">
            <img
              src={
                comment.maestra_imagen ||
                "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
              }
              alt="Profile"
            />
          </div>
          <div className="comm-12">
            <div className="comm-121">{comment.comment_text}</div>
            <div className="comm-122">✔️✔️ {comment.timestamp}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Comments;
